module.exports = __webpack_public_path__ + "img/dropdown_building.23f29204.svg";